import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async consultar(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('listas-costos-convenio/consultar'), { params: opciones.params });
  },
};
